import { z } from 'zod';
import { viewName } from './_shared';

export const app_opened = z.object({ from_install: z.boolean() }).strict();

export const view_switched = z.object({ from: viewName, to: viewName }).strict();

export const pwa_installed = z.object({}).strict();

// Outcome of requesting persistent (eviction-exempt) storage at boot. Lets us
// see how much of the user base has durable local-first storage vs. is at risk
// of silent eviction. Fired once per session.
export const persistent_storage = z.object({
  result: z.enum(['persisted', 'denied', 'unsupported', 'error']),
}).strict();
